import { editStoreBuilder } from '@/main/store/pages/edit/builder';

import { apiProvider } from '../../api';
import { CRUMB_LABEL_KEY as crumbLabel, DEPENDENT_TABLES, NAME as name } from '../../constants';
import { PovEdit, depTableSettings, PovDropdownList, props } from './state';

export const store = editStoreBuilder({
	apiProvider,
	crumbLabel,
	depTableNames: DEPENDENT_TABLES,
	depTableSettings,
	dropdownList: new PovDropdownList(),
	edit: new PovEdit(),
	extraActions: {},
	extraGetters: {},
	extraMutations: {},
	localState: {},
	name,
	props,
});
